/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Widget report designer component
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';

export const WidgetReportsConstructorContainerStyled = styled(WidgetBlockStyled)`
    .widget-reports-constructor__button,
    .widget-reports-constructor__button button {
        width: 100%;
    }
`;

export const WidgetReportsConstructorLabelStyled = styled.p`
    margin-top: 16px;
    margin-bottom: 4px;
    text-align: center;
`;

export const WidgetReportsConstructorTextStyled = styled.p`
    text-align: center;
    color: ${colors.textColorOpacity};
`;
